var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"count-ver"},[_c('span',[_vm._v(_vm._s(_vm.currentAge == 0 ? '<1' : _vm.currentAge))]),_vm._v(" "),_c('span',{staticClass:"dire-wrp"},[_c('i',{staticClass:"up",on:{"click":_vm.onUp}}),_vm._v(" "),_c('i',{staticClass:"down",on:{"click":_vm.onDown}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c80a6b98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckInNumber/age-ctrl.vue
// module id = null
// module chunks = 